import { isIOS, isSafari } from 'react-device-detect';
import {
  PHONE,
  PhoneDefinition,
  TEXT,
  VIDEO,
  VideoDefinition
} from '../../items';

import { useEditorStore } from '~/shell/Store';

interface PhoneMedia {
  mediaUrl?: string | null;
  subtitlesUrl?: string | null;
  autoPlay?: boolean | null;
  snapshotUrl?: string | null;
  hlsUrl?: string | null;
}

interface PhoneSrc {
  id?: string | number;
  title?: string | null;
  subtitle?: string | null;
  audios?: PhoneMedia[] | null;
  videos?: PhoneMedia[] | null;
  pictures?: Array<{ mediaUrl?: string | null }> | null;
}

interface PhoneInformation {
  narration?: string | null;
  subtitlesUrl?: string | null;
}

export const PhoneHelper = (
  src: PhoneSrc,
  information: PhoneInformation,
  personalization?: boolean,
  isolated?: boolean,
  blocking?: boolean,
  replay?: boolean
) => {
  const { contentEditable } = useEditorStore.getState();
  const title = !src.title && contentEditable ? 'Lorem Ipsum' : src.title;

  return {
    type: PHONE,
    id: src.id,
    values: src.audios?.length
      ? {
          type: 'audio',
          showProgress: true,
          name: src.subtitle || src.title,
          autoPlay: src.audios[0].autoPlay || false,
          mediaUrl: src.audios[0].mediaUrl,
          subtitlesUrl: src.audios[0].subtitlesUrl,
          photo: src.pictures?.[0]?.mediaUrl,
          personalization: personalization || false
        }
      : src.videos?.length
        ? {
            type: 'video',
            showProgress: true,
            name: src.subtitle || src.title,
            autoPlay: src.videos[0].autoPlay || false,
            mediaUrl: src.videos[0].mediaUrl,
            subtitlesUrl: src.videos[0].subtitlesUrl,
            photo: src.pictures?.[0]?.mediaUrl,
            personalization: personalization || false
          }
        : {
            type: 'audio',
            showProgress: true,
            name: src.subtitle || src.title,
            autoPlay: false,
            mediaUrl: information.narration,
            subtitlesUrl: information.subtitlesUrl,
            photo: src.pictures?.[0]?.mediaUrl,
            personalization: personalization || false
          },

    items: src.videos?.length
      ? [
          {
            type: VIDEO,
            id: `${src.id}-video`,
            values: {
              blocking: blocking === undefined ? false : blocking,
              isolated: isolated === undefined ? true : isolated,
              showPlayButton: true,
              autoPlay: src.videos[0].autoPlay || false,
              mediaUrl:
                isIOS || isSafari
                  ? ([
                      src.videos[0].mediaUrl && {
                        src: src.videos[0].mediaUrl,
                        type: 'video/mp4'
                      }
                    ].filter(Boolean) as Array<{ src: string; type: string }>)
                  : ([
                      src.videos[0].hlsUrl && {
                        src: src.videos[0].hlsUrl,
                        type: 'application/vnd.apple.mpegurl'
                      },
                      src.videos[0].mediaUrl && {
                        src: src.videos[0].mediaUrl,
                        type: 'video/mp4'
                      }
                    ].filter(Boolean) as Array<{ src: string; type: string }>),
              subtitlesUrl: src.videos[0].subtitlesUrl || '',
              snapshotUrl: src.videos[0].snapshotUrl || '',
              replay: replay || false
            }
          } as VideoDefinition
        ]
      : [
          {
            type: TEXT,
            id: src.id + '_title',
            items: [],
            values: {
              value: title,
              variant: 'text',
              disableRewrite: true
            }
          }
        ]
  } as PhoneDefinition;
};
